import { IGroup } from "@nju/data-access-portal-dashboard";
import { IMobileAccess } from "@nju/data-access-portal-product";
import { Icon } from "@nju/icons";
import { Button, Heading, Panel, Separator, Text } from "@nju/ui";
import { StatusBadge } from "../partials/StatusBadge";
import type { IPhaseProps } from "../partials/types";

export interface ICustomerStatusMobileProductCardProps {
  phase: IPhaseProps;
  groups: IGroup[] | undefined;
  mobileAccess: IMobileAccess | undefined;
  handleRedirectMobile: () => void;
  handleRedirectDetails: () => void;
}

export function CustomerStatusMobileProductCard({
  phase,
  groups,
  mobileAccess,
  handleRedirectMobile,
  handleRedirectDetails,
}: ICustomerStatusMobileProductCardProps) {
  const msisdn = mobileAccess?.characteristic?.msisdn;
  const primaryMsisdn = groups?.[0].members.filter((member) => {
    return member.primaryMsisdn;
  });
  const selectedMsisdn = groups?.[0].members.filter((member) => {
    return member.selectedMsisdn;
  });
  const msisdnCapacity = groups?.[0].metadata.capacity;

  return (
    <div data-cy="mobile-voice-status-section">
      <Panel
        badge={{
          body: phase === "phaseResignation" && (
            <StatusBadge icon="times-circle" text="rezygnacja z usługi" />
          ),
          variant: "ripeLemon",
        }}
        forceShowTitleBlock={true}
        height="full"
        iconName="mobile"
        invisibleSeparator={true}
        separatorSize="none"
      >
        <div className="flex flex-col justify-between">
          <div>
            <Separator size="xs" tone="invisible" />
            <Heading font="ttfirs" tone="neutral" variant="h3" weight="bold">
              nju subskrypcja z TV
            </Heading>
          </div>
          <Separator size="xs" tone="invisible" />
          {phase === "phaseResignation" && msisdn && (
            <div>
              <Text weight="bold">numer usługi:</Text>
              <Text className="pl-1" tone="accent" weight="bold">
                {msisdn}
              </Text>
            </div>
          )}
          {phase !== "phaseResignation" && (
            <div>
              <div data-cy="available-msisdns-number">
                <Text weight="bold">numery do sprzedania:</Text>
                <Text className="pl-1" tone="accent" weight="bold">
                  {msisdnCapacity}
                </Text>
              </div>
              <Separator tone="invisible" />
              {msisdnCapacity !== 0 && (
                <Button
                  display="inlineFlex"
                  onPress={handleRedirectMobile}
                  size="inline"
                  variant="simple"
                >
                  <div className="flex gap-3 items-center">
                    <Text tone="accent">sprzedaj</Text>
                    <Icon
                      height={18}
                      name="arrow-right"
                      tone="accent"
                      width={18}
                    />
                  </div>
                </Button>
              )}
              <Separator size="m" tone="complementary" />
              <div data-cy="purchased-msisdns-number">
                <Text weight="bold">kupione numery:</Text>
                <Text className="pl-1" tone="accent" weight="bold">
                  {primaryMsisdn?.length}
                </Text>
              </div>
              <div data-cy="fulfillment-msisdns-number">
                <Text weight="bold">w trakcie realizacji:</Text>
                <Text className="pl-1" tone="accent" weight="bold">
                  {selectedMsisdn?.length}
                </Text>
              </div>
              <Separator tone="invisible" />
              {(primaryMsisdn?.length !== 0 ||
                selectedMsisdn?.length !== 0) && (
                <Button
                  display="inlineFlex"
                  onPress={handleRedirectDetails}
                  size="inline"
                  variant="simple"
                >
                  <div className="flex gap-3 items-center">
                    <Text tone="accent">sprawdź szczegóły</Text>
                    <Icon
                      height={18}
                      name="arrow-right"
                      tone="accent"
                      width={18}
                    />
                  </div>
                </Button>
              )}
            </div>
          )}
        </div>
      </Panel>
    </div>
  );
}
